import { AuthService } from 'src/app/services/auth/auth.service';

/**
 * MARCAS DE «YA LIQUIDADO» (EST-01 a 09; maqueta traza-credito-pago, Mario 12-oct). Lo común a las cuatro
 * pantallas que las muestran: Consultas → «Buscar crédito o pago», la ficha del crédito, los pagos del cliente
 * (y la conciliación) y la ficha del comercio → «Liquidación».
 */

/**
 * EST-08: solo con `liquidacion.consultar`, y ESTRICTO como el núcleo: un usuario sin RBAC no lo tiene
 * (el núcleo le responde 403). Por eso no se usa `hasPermission` a secas, que sin RBAC deja pasar todo.
 * Sin el permiso la pantalla no muestra nada nuevo y no llama al núcleo.
 */
export const puedeVerLiquidacion = (auth: AuthService): boolean =>
  !!auth && auth.hasRbac$.getValue() && auth.hasPermission('liquidacion.consultar');

/** El color de cada estado (el texto lo pone el núcleo en `texto`). Lo que no está aquí va neutro. */
export const GRUPOS_MARCA = {
  exito: ['PAGADO', 'LIQUIDADO'],
  alerta: ['POR_PAGAR', 'EN_LOTE', 'EN_CIERRE', 'PASO_A_MANANA', 'ARRASTRADA', 'PARCIAL', 'VARIOS'],
  peligro: ['NO_PROCESADO', 'RETENIDO', 'REVERSADO', 'DESCONOCIDO'],
};

export const claseMarca = (estado: string | null | undefined): string => {
  const e = String(estado || '');
  if (GRUPOS_MARCA.exito.includes(e)) return 'kb-badge-exito';
  if (GRUPOS_MARCA.alerta.includes(e)) return 'kb-badge-alerta';
  if (GRUPOS_MARCA.peligro.includes(e)) return 'kb-badge-peligro';
  return 'kb-badge-neutro';
};

/** Texto corto cuando el núcleo no trae `texto` (la lista de ventas del comercio en cesión de deuda). */
export const TEXTO_MARCA: Record<string, string> = {
  // EST-11: «Liquidado» solo cuando ya se le pagó al comercio.
  PAGADO: 'Liquidado · pagado al comercio', POR_PAGAR: 'En proceso · por pagar', EN_LOTE: 'En proceso · en un lote', NO_PROCESADO: 'En proceso · no procesado por el banco',
  EN_CIERRE: 'En el cierre · por aprobar', PASO_A_MANANA: 'Pasó a mañana', ARRASTRADA: 'Arrastrada', POR_LIQUIDAR: 'Por liquidar',
  ANTERIOR: 'Liquidada por el proceso anterior', SIN_CONTRATO: 'No se liquida (sin contrato)', NO_APLICA: 'No aplica · cesión de deuda',
  RETENIDO: 'Retenido · no entra', LIQUIDADO: 'Liquidado · pagado al comercio', REVERSADO: 'Reversado', POR_COBRAR: 'Por cobrar al cliente', PARCIAL: 'Cobrada en parte',
};

/** 2026-10-15 → 15/10/2026 (o 15/10 con `corta`). */
export const fechaLiq = (iso: string | null | undefined, corta = false): string => {
  if (!iso) return '—';
  const s = String(iso);
  return corta ? `${s.slice(8, 10)}/${s.slice(5, 7)}` : `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}`;
};

/** La marca corta de un pago en las tablas (maqueta escenario 5), de la respuesta de POST /estado/pagos. */
export const etiquetaPago = (m: any): string => {
  if (!m) return '';
  const d = m.dia_cierre ? fechaLiq(m.dia_cierre, true) : '';
  const monto = (n: any) => Math.abs(Number(n) || 0).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (m.estado === 'EN_CIERRE') return `En el cierre${d ? ` ${d}` : ''}`;
  if (m.estado === 'NO_APLICA') return 'No aplica · cesión de deuda';
  if (m.estado === 'RETENIDO') return 'Retenido · no entra';
  if (m.reverso) return `${m.liquidacion || 'Liquidado'} · reverso −${monto(m.reverso.monto)} ${m.reverso.liquidacion ? `en ${m.reverso.liquidacion}` : 'por descontar'}`;
  if (m.liquidacion) return `${m.liquidacion}${d ? ` · ${d}` : ''}`;
  return m.texto || m.estado || '';
};
